package one.healthium.uscreen.ui.blocks

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import one.healthium.uscreen.domain.models.NotificationPreviewBlock

@Composable
actual fun UScreenNotificationPreviewBlock(
    modifier: Modifier,
    block: NotificationPreviewBlock,
    placeholders: Map<String, String>,
) {
    // Not implemented for JS target
}
